export const menu = [
  {
    label: 'محصولات',
    img: '/img/new/menu/products.webp',
    groups: [
      [
        {
          title: 'زیرساخت‌های ارتباطی',
          items: [
            {
              title: 'مرکز تلفن ابری',
              icon: 'nava-icon:products-cloud-pbx',
              path: '/products/cloud-pbx/', 
              img: '/img/new/menu/cloud-pbx.webp'
            },
            {
              title: 'خط تلفن اینترنتی',
              icon: 'nava-icon:products-internet-phone',
              path: '/products/internet-phone/', 
              img: '/img/new/menu/internet-phone.webp'
            },
            {
              title: 'پنل پیامکی',
              icon: 'nava-icon:products-sms',
              path: '/products/sms/', 
              img: '/img/new/menu/sms.webp'
            },
            {
              title: 'چت‌آنلاین سایت',
              icon: 'nava-icon:products-webchat',
              path: '/products/webchat/', 
              img: '/img/new/menu/webchat.webp'
            },
            {
              title: 'فکس آنلاین',
              icon: 'nava-icon:products-fax',
              path: '/products/fax/', 
              img: '/img/new/menu/fax.webp'
            },
          ]
        },
      ],
      [
        {
          title: 'ابزارهای مدیریت کسب‌وکار',
          items: [
            {
              title: 'CRM آنلاین',
              icon: 'nava-icon:products-crm',
              path: '/products/crm/', 
              img: '/img/new/menu/crm.webp'
            },
            // {
            //   title: 'ارزیابی عملکرد',
            //   icon: 'solar:clipboard-check-linear',
            //   path: '', 
            //   img: '/img/new/menu/performance-evaluation.webp'
            // },
            {
              title: 'اپلیکیشن اختصاصی',
              icon: 'nava-icon:products-nava-app',
              path: '/products/dedicated-application/', 
              img: '/img/new/menu/nava-app.webp'
            },
            {
              title: 'پنل مدیریتی',
              icon: 'solar:laptop-minimalistic-linear',
              path: '/products/management-dashboard/', 
              img: '/img/new/menu/management-dashboard.webp'
            },
            {
              title: 'تلفن گویا',
              icon: 'solar:headphones-round-sound-linear',
              path: '/products/smart-ivr/', 
              img: ''
            },
            // {
            //   title: 'تاریخچه تعاملات',
            //   icon: 'solar:hand-money-linear',
            //   path: '', 
            //   img: ''
            // },
          ]
        },
      ],
      [
        {
          title: 'محصولات ابری مخابرات استان تهران',
          items: [
            {
              title: 'پیش‌شماره 8 مخابرات استان تهران',
              icon: 'nava-icon:tci-linear',
              path: '/rond/', 
              img: '/img/new/menu/8-prefix.webp'
            },
            {
              title: 'خطوط 4 رقمی مخابرات',
              icon: 'nava-icon:tci-linear',
              path: '/products/4-digit-line/', 
              img: '/img/new/menu/4-digit-line.webp'
            },
            {
              title: 'خطوط 5 رقمی مخابرات',
              icon: 'nava-icon:tci-linear',
              path: '/products/5-digit-line/', 
              img: '/img/new/menu/5-digit-line.webp'
            },
            {
              title: 'مرکز تماس ابری مخابرات ایران (متاما)',
              icon: 'nava-icon:tci-linear',
              path: '/metama/', 
              img: '/img/new/menu/metama.webp'
            },
          ]
        },
      ],
    ]
  },
  // {
  //   label: 'شرکای تجاری',
  //   img: '/img/new/menu/partners.webp',
  //   groups: [
  //     [
  //       {
  //         title: 'شریک فناوری و تجاری',
  //         items: [
  //           {
  //             title: 'مخابرات ایران',
  //             icon: 'nava-icon:tci-linear',
  //             path: '/products/cloud-pbx/', 
  //             img: '/img/new/menu/tci.webp'
  //           },
  //           {
  //             title: 'ایرانسل',
  //             icon: 'nava-icon:irancell-linear',
  //             path: '/products/cloud-pbx/', 
  //             img: '/img/new/menu/irancell.webp'
  //           },
  //         ]
  //       },
  //     ],
  //     [
  //       {
  //         title: 'شریک زیرساخت',
  //         items: [
  //           {
  //             title: 'آسیاتک',
  //             icon: 'nava-icon:asiatech-linear',
  //             path: '/products/cloud-pbx/', 
  //             img: '/img/new/menu/asiatek.webp'
  //           },
  //         ]
  //       },
  //       {
  //         title: 'شریک نمایندگان فروش',
  //         items: [
  //           {
  //             title: 'دفاتر پیشخوان دولت',
  //             icon: 'nava-icon:pishkhan-linear',
  //             path: '/products/cloud-pbx/', 
  //             img: '/img/new/menu/pishkhan.webp'
  //           },
  //         ]
  //       },
  //     ],
  //   ]
  // },
  {
    label: 'ارتباط با ما',
    img: '/img/new/menu/contact.webp',
    groups: [
      [
        {
          title: 'درباره ما',
          items: [
            {
              title: 'درباره ما',
              icon: 'nava-icon:navatel-linear',
              path: '/about-us/', 
              img: '/img/new/menu/about-us.webp'
            },
            {
              title: 'مدیر عامل و معاونین',
              icon: 'solar:users-group-two-rounded-linear',
              path: '/managers/', 
              img: '/img/new/menu/manager.webp'
            },
            // {
            //   title: 'نمایشگاه‌ها و رویدادها',
            //   icon: 'solar:shop-minimalistic-linear',
            //   path: '', 
            //   img: ''
            // },
          ]
        },
      ],
      [
        {
          title: 'تماس با ما',
          items: [
            {
              title: 'تماس با ما',
              icon: 'solar:phone-calling-linear',
              path: '/contact-us/', 
              img: '/img/new/menu/contact-us.webp'
            },
            {
              title: 'فرم درخواست نمایندگی',
              icon: 'solar:pen-new-square-linear',
              path: '/sales-agent/', 
              img: '/img/new/menu/sales-agent.webp'
            },
            {
              title: 'پشتیبانی',
              icon: 'solar:headphones-round-sound-linear',
              path: '/support/', 
              img: '/img/new/menu/support.webp'
            },
          ]
        },
      ],
    ]
  },
  {
    label: 'منابع',
    img: '/img/new/menu/sources.webp',
    groups: [
      [
        {
          title: 'آموزش و راهنما',
          items: [
            {
              title: 'بلاگ',
              icon: 'solar:notebook-bookmark-linear',
              path: 'https://navatel.ir/blog/', 
              targetBlank: true,
              img: '/img/new/menu/blog.webp'
            },
            // {
            //   title: 'پایگاه دانش',
            //   icon: 'solar:square-academic-cap-2-linear',
            //   path: '/products/cloud-pbx/', 
            //   img: '/img/new/menu/knoweledge-base.webp'
            // },
            // {
            //   title: 'سوالات متداول',
            //   icon: 'solar:question-square-linear',
            //   path: '/products/cloud-pbx/', 
            //   img: '/img/new/menu/faq.webp'
            // },
            {
              title: 'کاتالوگ',
              icon: 'solar:documents-linear',
              path: 'https://navatel.ir/Digital-Catalogue/', 
              img: '/img/new/menu/catalogue.webp'
            },
          ]
        },
      ],
      // [
      //   {
      //     title: 'مستندات',
      //     items: [
      //       {
      //         title: 'مستندات API',
      //         icon: 'solar:code-file-linear',
      //         path: '/products/cloud-pbx/', 
      //         img: '/img/new/menu/api.webp'
      //       },
      //     ]
      //   },
      // ],
    ]
  },
  { label: 'تعرفه‌ها', path: '/prices/' },
];
export type TMenu = typeof menu;
export type TMenuItem = TMenu[number];